module.exports = __webpack_public_path__ + "static/media/login_wallpaper.60d849d4.jpg";